import React from 'react';
import CustomContainer from './CustomContainer';
import { TextField } from '@material-ui/core';
import { useLang } from '../../../util/lang';

const SpecialInstruction = ({ impressionType, disabled = false, value = '', onChange }) => {
    const getNotes = useLang('NewPatient');
    return (
        <CustomContainer style={{ display: !impressionType && 'none' }}>
            <h4>{getNotes('prescriptionNotes.specialInstructionsDescription')}</h4>
            <TextField
                disabled={disabled}
                value={value}
                onChange={onChange && onChange}
                style={{ width: '80%' }}
                rows={4}
                multiline
                variant="outlined"
                margin="normal"
            />
        </CustomContainer>
    );
};

export default SpecialInstruction;
